module.exports = __webpack_public_path__ + "static/media/textures.e8a3091f.jpg";